import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/DateRenderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/FallBackImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/pages/CategoryOrTagPage/PostsWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/static-page.module.scss");
